import { trigger, state, style, transition, animate } from '@angular/animations';
import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { getPropertyValue } from 'src/app/shared/tables.helper';

@Component({
    selector: 'app-bulk-data-upload-table',
    templateUrl: './bulk-data-upload-table.component.html',
    styleUrls: ['./bulk-data-upload-table.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('true', style({ height: '*', opacity: 1 })),
            state('false', style({ height: '0', opacity: 0 })),
            transition('false <=> true', [animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
            transition(':leave', [animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '0', opacity: 0 }))]),
        ]),
    ],
})
export class BulkDataUploadTableComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @Input() dataSource: MatTableDataSource<any>;
    @Input() displayedColumns: any[];
    @Input() columnsToDisplay: string[];

    public pageSizeOptions = [5, 10, 20];
    public pageDefaultSize = 5;
    public expandedElement: any | null = null;
    public getPropertyValue = getPropertyValue;

    constructor() {}

    ngAfterViewInit(): void {
        this.initializeDataSource();
    }

    ngOnInit(): void {
        this.dataSource.paginator = this.paginator;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource'] && this.dataSource) {
            this.dataSource.paginator = this.paginator;
        }
    }

    private initializeDataSource = () => {
        setTimeout(() => {
            if (this.dataSource) {
                this.dataSource.paginator = this.paginator;
            }
        });
    };

    toggleRow(element: any): void {
        this.expandedElement = this.expandedElement === element ? null : element;
    }
}
